import { createContext, useEffect, useState } from "react";

const CU_FILTER_DEFAULT_VALUES = {
  bg: [],
  subcategory: [],
  branch: [],
  brand: [],
  format: [],
  basepack: [],
  factory: [],
  year: [],
};

const DEMAND_FILTER_DEFAULT_VALUES = {
  bg: [],
  subcategory: [],
  branch: [],
  cluster: [],
  depot: [],
  brand: [],
  format1: [],
  format: [],
  basepack: [],
  year: [],
};

const CAPACITY_FILTER_DEFAULT_VALUES = {
  product_type: [],
  basepack: [],
  cascade: [],
  factory: [],
  line: [],
  year: [],
};

const ALERT_FILTER_DEFAULT_VALUES = {
  bg: [],
  subcategory: [],
  location: [],
  format: [],
};

const SIMULATION_FILTER_DEFAULT_VALUES = {
  producttype: [],
  factory: [],
};

const ALERT_WIDGET_DEFAULT_VALUES = {
  open: false,
  success: null,
  message: null,
  onClose: null,
};

const USER_ROLE_DEFAULT_VALUES = {
  all: false,
  bg: null,
  catg: null,
  mdm: false,
  role: false,
  write: false,
};

const CAPACITY_DEFAULT_VALUES = {
  basepack: "All",
  cascade: "All",
  factory: "All",
  line: "All",
  producttype: "All",
};

const COMMON_SELECTED_FILTER_DEFAULT_VALUES = {
  bgState: "All",
  subcategoryState: "All",
  branchState: "All",
  brandState: "All",
  formatState: "All",
  basepackState: "All",
  factoryState: "All",
  yearState: "All",
  quarterState: "All",
  monthState: "All",
  timeGranularity: null,
  load_ym: true,
  appliedFilters: [],
};

const DASHBOARD_SELECTED_FILTER_DEFAULT_VALUES = {
  // load_18_months:  true,
  mapGranularity: "Branch",
  tableLevel: "national",
};

const CU_SELECTED_FILTER_DEFAULT_VALUES = {
  // load_18_months: true ,
  cuConstrain: "pack_constrained",
};

const CAPACITY_SELECTED_FILTER_DEFAULT_VALUES = {
  productTypeState: null,
  cascadeState: null,
  lineState: null,
};

const DEMAND_SELECTED_FILTER_DEFAULT_VALUES = {
  // load_3_years: true,
  tableLevel: "national",
  clusterState: "All",
  depotState: "All",
  format1State: "All",
  appliedFilters: [],
};

const LTCPContext = createContext(null);

function LTCPContextProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [runtime, setRuntime] = useState("");
  const [runtype, setRuntype] = useState("");
  const [ribbonMessage, setRibbonMessage] = useState(null);
  const [demandFile, setDemandFile] = useState("V1Demand");
  const [cuFilters, setCuFilters] = useState(CU_FILTER_DEFAULT_VALUES);
  const [capacityDefault, setCapacityDefault] = useState(
    CAPACITY_DEFAULT_VALUES
  );
  const [demandFilters, setDemandFilters] = useState(
    DEMAND_FILTER_DEFAULT_VALUES
  );
  const [capacityFilters, setCapacityFilters] = useState(
    CAPACITY_FILTER_DEFAULT_VALUES
  );
  const [simulationFilters, setSimulationFilters] = useState(
    SIMULATION_FILTER_DEFAULT_VALUES
  );
  const [alertFilters, setAlertFilters] = useState(ALERT_FILTER_DEFAULT_VALUES);
  const [alertWidget, setAlertWidget] = useState(ALERT_WIDGET_DEFAULT_VALUES);
  const [currentUserRole, setCurrentUserRole] = useState(
    USER_ROLE_DEFAULT_VALUES
  );
  const [branchFactoryMap, setBranchFactoryMap] = useState({});
  const [allRunDetails, setAllRunDetails] = useState({});
  const [runDetails, setRunDetails] = useState({});
  const [demandOptions, setDemandOptions] = useState({});
  const [runTimeOptions, setRunTimeOptions] = useState([]);
  const [productType, setProductType] = useState("");
  const [thresholdLevel, setThresholdLevel] = useState({});
  const [acceptFeature, setAcceptFeature] = useState(true);
  const [commonSelectedFilters, setCommonSelectedFilters] = useState(
    COMMON_SELECTED_FILTER_DEFAULT_VALUES
  );
  const [dashboardSelectedFilters, setDashboardSelectedFilters] = useState(
    DASHBOARD_SELECTED_FILTER_DEFAULT_VALUES
  );
  const [cuSelectedFilters, setCuSelectedFilters] = useState(
    CU_SELECTED_FILTER_DEFAULT_VALUES
  );
  const [demandSelectedFilters, setDemandSelectedFilters] = useState(
    DEMAND_SELECTED_FILTER_DEFAULT_VALUES
  );
  const [capacitySelectedFilters, setCapacitySelectedFilters] = useState(
    CAPACITY_SELECTED_FILTER_DEFAULT_VALUES
  );

  // store the current filter value
  const [pipelineManualProductType, setPipelineManualProductType] =
    useState("");
  const [pipelineManualTimeStamp, setPipelineManualTimeStamp] = useState("");
  const [pipelineScheduleTimeStamp, setPipelineScheduleTimeStamp] =
    useState("");

  // store the filter dropdown values
  const [
    pipelineManualProductTypeOptions,
    setPipelineManualProductTypeOptions,
  ] = useState([]);
  const [pipelineManualTimeStampOptions, setPipelineManualTimeStampOptions] =
    useState([]);
  const [
    pipelineScheduleTimeStampOptions,
    setPipelineScheduleTimeStampOptions,
  ] = useState([]);

  // store the hierarchy data
  const [pipelineStatusFilter, setPipelineStatusFilter] = useState({
    manual: {},
    schedule: [],
  });

  function loadPipelineStatusFilter(filters) {
    try {
      setPipelineStatusFilter(filters);

      if (filters["schedule"].length > 0) {
        setPipelineScheduleTimeStampOptions(filters["schedule"]);
        setPipelineScheduleTimeStamp(filters["schedule"][0]);
      } else {
        setPipelineScheduleTimeStampOptions([]);
        setPipelineScheduleTimeStamp("");
      }

      let ptypes = Object.keys(filters["manual"]);
      if (ptypes.length > 0) {
        setPipelineManualProductTypeOptions(ptypes);

        let currentPType = ptypes[0];
        let tstamps = filters["manual"][ptypes[0]];

        for (let i = 1; i < ptypes.length; i++) {
          let tmpTStamps = filters["manual"][ptypes[i]];

          if (tmpTStamps[0].localeCompare(tstamps[0]) > 0) {
            tstamps = tmpTStamps;
            currentPType = ptypes[i];
          }
        }

        setPipelineManualProductType(currentPType);
        if (tstamps.length > 0) {
          setPipelineManualTimeStampOptions(tstamps);
          setPipelineManualTimeStamp(tstamps[0]);
        } else {
          setPipelineManualTimeStampOptions([]);
          setPipelineManualTimeStamp("");
        }
      } else {
        setPipelineManualProductTypeOptions([]);
        setPipelineManualProductType("");

        setPipelineManualTimeStampOptions([]);
        setPipelineManualTimeStamp("");
      }
    } catch (e) {
      console.error(e);
    }
  }

  function changePipelineManualProductType(value) {
    try {
      setPipelineManualProductType(value);
      let tstamps = pipelineStatusFilter["manual"][value];

      if (tstamps.length > 0) {
        setPipelineManualTimeStampOptions(tstamps);
        setPipelineManualTimeStamp(tstamps[0]);
      } else {
        setPipelineManualTimeStampOptions([]);
        setPipelineManualTimeStamp("");
      }
    } catch (e) {
      console.error(e);
    }
  }

  function changePipelineManualTimeStamp(value) {
    try {
      setPipelineManualTimeStamp(value);
    } catch (e) {
      console.error(e);
    }
  }

  function changePipelineScheduleTimeStamp(value) {
    try {
      setPipelineScheduleTimeStamp(value);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <LTCPContext.Provider
      value={{
        loading,
        setLoading,
        alertFilters,
        setAlertFilters,
        demandFile,
        setDemandFile,
        cuFilters,
        setCuFilters,
        demandFilters,
        setDemandFilters,
        capacityFilters,
        setCapacityFilters,
        alertWidget,
        setAlertWidget,
        currentUserRole,
        setCurrentUserRole,
        runtime,
        setRuntime,
        runtype,
        setRuntype,
        branchFactoryMap,
        setBranchFactoryMap,
        allRunDetails,
        setAllRunDetails,
        runDetails,
        setRunDetails,
        runTimeOptions,
        setRunTimeOptions,
        productType,
        setProductType,
        simulationFilters,
        setSimulationFilters,
        ribbonMessage,
        setRibbonMessage,
        thresholdLevel,
        setThresholdLevel,
        capacityDefault,
        setCapacityDefault,
        acceptFeature,
        setAcceptFeature,
        demandOptions,
        setDemandOptions,
        commonSelectedFilters,
        setCommonSelectedFilters,
        dashboardSelectedFilters,
        setDashboardSelectedFilters,
        cuSelectedFilters,
        setCuSelectedFilters,
        demandSelectedFilters,
        setDemandSelectedFilters,
        capacitySelectedFilters,
        setCapacitySelectedFilters,

        loadPipelineStatusFilter,
        pipelineManualProductType,
        pipelineManualTimeStamp,
        pipelineScheduleTimeStamp,
        pipelineManualProductTypeOptions,
        pipelineManualTimeStampOptions,
        pipelineScheduleTimeStampOptions,
        changePipelineManualProductType,
        changePipelineManualTimeStamp,
        changePipelineScheduleTimeStamp,
      }}
    >
      {children}
    </LTCPContext.Provider>
  );
}

export { LTCPContext, LTCPContextProvider };
